export var RA_CHARGE_TYPE;
(function (RA_CHARGE_TYPE) {
    RA_CHARGE_TYPE["FULL"] = "FULL";
    RA_CHARGE_TYPE["PRORATED"] = "PRORATED";
    RA_CHARGE_TYPE["FULL_TO_RESIDENT"] = "FULL_TO_RESIDENT";
})(RA_CHARGE_TYPE || (RA_CHARGE_TYPE = {}));
export var RA_CHARGE_STATUS;
(function (RA_CHARGE_STATUS) {
    RA_CHARGE_STATUS["SUBMITTED"] = "SUBMITTED";
    RA_CHARGE_STATUS["COMPLETED"] = "COMPLETED";
})(RA_CHARGE_STATUS || (RA_CHARGE_STATUS = {}));
//# sourceMappingURL=RepairMaintenance.js.map